;(function($, undefined){
    var rnn = window.rnn;
    var protocol = window.location.protocol;
    var facebookApi = protocol + '//graph.facebook.com/';
    var shareURL = $('[property="og:url"]').attr('content');
    var title = $('[property="og:title"]').attr('content');
    var $facebookCounter = $('.facebook-counter');

    function getCounterFacebook(){
        var url = facebookApi + '?ids=' + encodeURIComponent(shareURL);

        $.getJSON(url, function(data){
            if (data[shareURL] && data[shareURL].share) {
                share_count = data[shareURL].share.share_count;
                if (share_count > 0) {
                    $facebookCounter.text(share_count);
                    $facebookCounter.show();
                } 
            }
        });
    }

    function openWindow(url){
        window.open(url,'','width=700,height=400');
    }

    function init(){
        // we ll hide it until we get results from the social graph api
        // its less risky to do it in js rather in css hopefully it does not flicker too much
        $facebookCounter.hide();

        if($('.shareTools').length || $('.metaBar').length){
            var $btnFacebookShare = $('.facebook-share'),
                $btnTwitterShare = $('.twitter-share');

            $btnFacebookShare.on('click',function(){
                var url = protocol + '//www.facebook.com/sharer.php?u=' + encodeURIComponent(shareURL);
                openWindow(url);
            });

            $btnTwitterShare.on('click',function(){
                var url = protocol + '//twitter.com/intent/tweet?original_referer='+encodeURIComponent(shareURL)+'&text='+encodeURIComponent(title)+'&url='+encodeURIComponent(shareURL);
                openWindow(url);
            });

            getCounterFacebook();
        }
    }

    rnn.modules.register('socialIcons', {
        init: init
    });
})(jQuery);
